import { UntypedFormBuilder } from '@angular/forms';
import { ProjectCreatorApiService } from '../services/project-creator-api.service';
import { BaseProjectCreator } from './base-project-creator.controller';

export class ProjectCreatorSecondStepController extends BaseProjectCreator {
  get defaultFormValues() {
    return {};
  }

  constructor(
    private fb: UntypedFormBuilder,
    private api: ProjectCreatorApiService
  ) {
    super();
    this.createForm(this.fb);
  }

  submit(token: string, step?: number): any {
    return this.api.getFullProjectData(token);
  }

  submitInternal(id: number, step?: number) {
    return this.api.getProjectById(id);
  }
}
